import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/groups.js";

export function useGroups(options = {}) {
  return useQuery({ queryKey: keys.groups.list, queryFn: api.fetchGroups, ...options });
}

export function useGroup(id, options = {}) {
  return useQuery({
    queryKey: keys.groups.detail(id),
    queryFn: () => api.fetchGroup(id),
    enabled: !!id,
    ...options,
  });
}

export function useCreateGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createGroup,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.groups.all }),
  });
}

export function useUpdateGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateGroup(id, data),
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: keys.groups.all });
      qc.invalidateQueries({ queryKey: keys.groups.detail(id) });
    },
  });
}

export function useDeleteGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, deleteMonitors = false }) =>
      api.deleteGroup(id, { deleteMonitors }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.groups.all });
      qc.invalidateQueries({ queryKey: keys.monitors.all });
    },
  });
}

export function useUpdateGroupMembers() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, monitorIds }) => api.updateGroupMembers(id, monitorIds),
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: keys.groups.detail(id) });
      qc.invalidateQueries({ queryKey: keys.groups.all });
    },
  });
}

export function useQuickSetup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.quickSetup,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.groups.all });
      qc.invalidateQueries({ queryKey: keys.monitors.all });
    },
  });
}
